import { React, useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { IoIosArrowDown } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@material-tailwind/react";
import logo from "/assets/images/logo-lolivier_nav.webp";
import "./nav.css";

export const NavBar = () => {
  const [active, setActive] = useState(false);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Ferme le menu si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setActive(false);
  }, [location]);

  useEffect(() => {
    if (active) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Nettoyer le style lors du démontage
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [active]);

  return (
    <>
      <header className="bg-white" id="navigation">
        <nav className="w-full relative flex items-center justify-between py-5 px-10 border-b-4 border-brown-00 border-vertLogo">
          <Link to="/">
            <div className="logo">
              <img src={logo} alt="" width={50} height={50} />
              <span className=" sr-only">lien vers l'accueil</span>
            </div>
          </Link>

          <button
            aria-label={active ? "Fermer le menu" : "Ouvrir le menu"}
            className={`menu-burger xl:hidden z-50 w-7 h-7 ${active && "fixed top-5 right-10"}`}
            onClick={() => {
              setActive(!active);
            }}
          >
            {active ? (
              <FontAwesomeIcon icon={faXmark} className="w-full h-full" />
            ) : (
              <FontAwesomeIcon icon={faBars} className="w-full h-full" />
            )}
          </button>
          <ul
            className={`group-links z-40 bg-[#F5F5DC]
              
             fixed h-full w-full ${
               active ? "left-1/2 -translate-x-1/2 " : "left-full"
             } top-1/2 transform -translate-y-1/2 flex flex-col pb-40 justify-center items-center xl:p-0 xl:bg-transparent xl:flex xl:flex-row xl:justify-normal xl:static xl:top-auto xl:left-auto xl:transform-none xl:w-auto xl:h-auto gap-8 text-xl font-medium`}
          >
            <li
              className="cursor-pointer relative"
              onMouseEnter={() => window.innerWidth >= 768 && setIsOpen(true)}
              // onMouseLeave={() => window.innerWidth >= 768 && setIsOpen(false)}
              ref={menuRef}
            >
              <button
                className="flex items-center gap-2"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Ouvrir le menu déroulant qui sommes nous"
              >
                Qui sommes-nous ?
                <IoIosArrowDown
                  className={`transition-transform ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {isOpen && (
                <ul
                  className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-md z-10"
                  onMouseEnter={() =>
                    window.innerWidth >= 768 && setIsOpen(true)
                  }
                  onMouseLeave={() =>
                    window.innerWidth >= 768 && setIsOpen(false)
                  }
                >
                  <li className="relative text-base px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to="/notre-histoire" className="block w-full">
                      Histoire
                    </Link>
                  </li>
                  <li className=" relative text-base px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to="/projet-pedagogique" className="block w-full">
                      Projet pédagogique
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className="relative cursor-pointer">
              <Link to="/evenements" className="block w-full">
                Évènements
              </Link>
            </li>
            <li className="cursor-pointer">
              <Link to="/modalites-inscription" className="block w-full">
                Inscription
              </Link>
            </li>
            <li className="cursor-pointer">
              <Link to="/nous-soutenir" className="block w-full">
                Nous soutenir
              </Link>
            </li>
            <Link to="/contact" aria-label="Contacter l’école">
              <Button
                className="text-sm bg-vertLogo"
                variant="outline"
                aria-label="bouton contactez nous"
                tabIndex={-1}
              >
                <span>Contactez-Nous</span>
              </Button>
            </Link>
          </ul>
        </nav>
      </header>
    </>
  );
};
